import { useLocation } from 'react-router-dom';

import { Seo } from '@/components/Seo';

const routeSeo = {
  '/': {
    title: 'Solar Installations & Backup Power | Green Light City',
    description: 'Green Light City provides solar installations, inverter systems, battery backup and electrical solutions for South African homes and businesses.',
  },
  '/services': {
    title: 'Solar, Battery & Electrical Services | Green Light City',
    description: 'Explore residential and commercial solar installations, battery backup, electrical construction and solar maintenance services from Green Light City.',
  },
  '/products': {
    title: 'Solar Inverters, Batteries & Panels | Green Light City',
    description: 'Explore solar inverters, lithium batteries and solar panels from Fox ESS, Sunsynk and JA Solar, installed and supported by Green Light City.',
  },
  '/projects': {
    title: 'Solar Installation Projects | Green Light City',
    description: 'View Green Light City residential, commercial and electrical installation projects across South Africa.',
  },
  '/blog': {
    title: 'Solar Insights & Energy Guides | Green Light City',
    description: 'Read practical solar power, battery backup, SSEG and renewable energy guides from Green Light City.',
  },
  '/about': {
    title: 'About Green Light City | Solar Installation Team',
    description: 'Learn about Green Light City, our certified solar and electrical team, and our commitment to practical, quality energy solutions.',
  },
  '/faq': {
    title: 'Solar Installation FAQs | Green Light City',
    description: 'Find answers about solar installations, inverter sizing, battery backup, SSEG requirements, warranties and maintenance.',
  },
  '/contact': {
    title: 'Request a Solar Quote | Green Light City',
    description: 'Contact Green Light City for a solar installation, battery backup, inverter, electrical or maintenance quote.',
  },
  '/inverter-game': {
    title: 'Build a Solar & Inverter System | Green Light City',
    description: 'Estimate appliance loads and explore suitable inverter, battery and solar panel combinations with Green Light City’s interactive system builder.',
  },
  '/solar-roi-calculator': {
    title: 'Solar ROI Calculator South Africa | Green Light City',
    description: 'Estimate potential solar savings and payback periods for a South African home or business with Green Light City’s solar ROI calculator.',
  },
  '/how-solar-batteries-work': {
    title: 'How Solar Batteries Work | Green Light City',
    description: 'See how solar panels, inverters, batteries, the grid and backup loads work together throughout the day and during outages.',
  },
};

export const RouteSeo = () => {
  const { pathname } = useLocation();
  const normalizedPath = pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname;
  const metadata = routeSeo[normalizedPath];

  if (metadata) {
    return <Seo {...metadata} path={normalizedPath} />;
  }

  if (normalizedPath === '/admin' || normalizedPath === '/thank-you' || normalizedPath.startsWith('/lp/')) {
    return (
      <Seo
        title="Green Light City"
        description="Green Light City solar and energy solutions."
        path={normalizedPath}
        robots="noindex, nofollow"
      />
    );
  }

  return null;
};
